$(document).ready(function()
{
    function standardObserver(element_name_class)
    {
        
        function observerCallback(entries) 
        {
            entries.forEach((entry) => 
            {
                if (entry.isIntersecting) 
                {
                    entry.target.classList.add('show-animation');
                }
            });
        }
        const observerOptions = 
        {
            root: null,
            rootMargin: '0px',
            threshold: 0.3,
        };
        const elementsToLoadIn = document.querySelectorAll(element_name_class);
        elementsToLoadIn.forEach((el) => 
        {
            el.classList.add('pre-animation');
        });

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        elementsToLoadIn.forEach((el) => observer.observe(el));
    }


    if ($(".button_ctas .btn").length)
    {
        standardObserver(".button_ctas .btn");
    }
});